import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import Proptypes from 'prop-types';

function Link({ to, children, type = 'primary' }) {
  const style = {
    primary: 'button button--primary',
  };

  return (
    <GatsbyLink to={to} className={style[type]}>
      {children}
    </GatsbyLink>
  );
}

Link.propTypes = {
  children: React.ReactNode,
  to: Proptypes.string.isRequired,
  type: Proptypes.string,
};

export default Link;
